/**
 * Brief "GET READY" splash shown during the GET_READY phase of each round.
 */

export interface RoundSplashHandle {
  show(title: string, sub: string): void;
  dispose(): void;
}

const ROOT_ID = 'cm-splash';

export function createRoundSplash(stage: HTMLElement): RoundSplashHandle {
  ensureStyles();
  const root = document.createElement('div');
  root.id = ROOT_ID;
  root.innerHTML = `
    <div class="cm-splash-grid">
      <span class="cm-splash-title" data-cm-splash-title></span>
      <span class="cm-splash-sub" data-cm-splash-sub></span>
    </div>
  `;
  root.style.display = 'none';
  stage.appendChild(root);

  let timer: ReturnType<typeof setTimeout> | null = null;

  function show(title: string, sub: string): void {
    const titleEl = root.querySelector('[data-cm-splash-title]');
    const subEl = root.querySelector('[data-cm-splash-sub]');
    if (titleEl) titleEl.textContent = title;
    if (subEl) subEl.textContent = sub;
    root.style.display = '';
    root.classList.add('cm-splash-show');
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      root.classList.remove('cm-splash-show');
      setTimeout(() => {
        root.style.display = 'none';
      }, 400);
    }, 4500); // 5s total - 0.5s fade-out
  }

  return {
    show,
    dispose() {
      if (timer) clearTimeout(timer);
      root.remove();
    },
  };
}

function ensureStyles(): void {
  if (document.getElementById('cm-splash-style')) return;
  const s = document.createElement('style');
  s.id = 'cm-splash-style';
  s.textContent = `
    #${ROOT_ID} {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      /* Above round scene (z-index: 30) and side-leaderboard (z-index: 50)
         so the GET READY splash modal renders on top of the tile grid. */
      z-index: 80;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.35s;
    }
    #${ROOT_ID}.cm-splash-show { opacity: 1; }
    #${ROOT_ID} .cm-splash-grid {
      text-align: center;
      padding: 60px 100px;
      background: rgba(10, 14, 39, 0.92);
      border: 2px solid var(--sg-secondary, #06B6D4);
      border-radius: 24px;
      box-shadow: 0 0 80px rgba(168, 85, 247, 0.4);
    }
    #${ROOT_ID} .cm-splash-title {
      display: block;
      font-family: 'Bebas Neue', sans-serif;
      font-size: 140px;
      letter-spacing: 8px;
      background: linear-gradient(180deg, var(--sg-primary, #A855F7), var(--sg-accent, #EC4899));
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }
    #${ROOT_ID} .cm-splash-sub {
      display: block;
      font-family: 'Inter', sans-serif;
      font-size: 36px;
      color: rgba(255,255,255,0.8);
      margin-top: 8px;
      letter-spacing: 4px;
    }
  `;
  document.head.appendChild(s);
}
